import { AnimateHeight } from './AnimateHeight';
import { AnimateRotate } from './AnimateRotate';

// can serve as a HOC with some general settings for the other subcomponents
export const Animate = () => {
  // Empty
};

Animate.Height = AnimateHeight;
Animate.Rotate = AnimateRotate;
